/**
 * Base API
 * API for Base Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RubrikConfigEntry { 
    rubrik?: RubrikConfigEntry.RubrikEnum;
    id?: string;
    components?: Array<string>;
    rubrikType?: RubrikConfigEntry.RubrikTypeEnum;
    hashCode?: string;
    titel?: string;
}
export namespace RubrikConfigEntry {
    export type RubrikEnum = 'GB_AUSZUG_UNBEKANNT' | 'GB_AUSZUG_LIG' | 'GB_AUSZUG_MIT' | 'GB_AUSZUG_STW' | 'GB_AUSZUG_SDR' | 'GB_AUSZUG_SEYBUCH' | 'GB_UEBERSICHT_LIG' | 'GB_UEBERSICHT_MIT' | 'GB_UEBERSICHT_STW' | 'GB_UEBERSICHT_SDR' | 'GB_DETAIL_PFANDRECHT' | 'GB_DETAIL_STANDARDRECHT' | 'GB_DETAIL_GRUNDSTUECK';
    export const RubrikEnum = {
        AUSZUGUNBEKANNT: 'GB_AUSZUG_UNBEKANNT' as RubrikEnum,
        AUSZUGLIG: 'GB_AUSZUG_LIG' as RubrikEnum,
        AUSZUGMIT: 'GB_AUSZUG_MIT' as RubrikEnum,
        AUSZUGSTW: 'GB_AUSZUG_STW' as RubrikEnum,
        AUSZUGSDR: 'GB_AUSZUG_SDR' as RubrikEnum,
        AUSZUGSEYBUCH: 'GB_AUSZUG_SEYBUCH' as RubrikEnum,
        UEBERSICHTLIG: 'GB_UEBERSICHT_LIG' as RubrikEnum,
        UEBERSICHTMIT: 'GB_UEBERSICHT_MIT' as RubrikEnum,
        UEBERSICHTSTW: 'GB_UEBERSICHT_STW' as RubrikEnum,
        UEBERSICHTSDR: 'GB_UEBERSICHT_SDR' as RubrikEnum,
        DETAILPFANDRECHT: 'GB_DETAIL_PFANDRECHT' as RubrikEnum,
        DETAILSTANDARDRECHT: 'GB_DETAIL_STANDARDRECHT' as RubrikEnum,
        DETAILGRUNDSTUECK: 'GB_DETAIL_GRUNDSTUECK' as RubrikEnum
    };
    export type RubrikTypeEnum = 'PRINT' | 'VIEW';
    export const RubrikTypeEnum = {
        PRINT: 'PRINT' as RubrikTypeEnum,
        VIEW: 'VIEW' as RubrikTypeEnum
    };
}


